import { useQuery } from '@tanstack/react-query';
import {
  StatusCode,
  getApiV2ProductsId,
  getProductPath,
  type GetProductV2Params as GetProductParams,
  type ProductDetail,
} from '@hungryroot/rest';

type OptionType = {
  enabled?: boolean;
  initialData?: ProductDetail;
};

export function useProduct(
  queryParams: GetProductParams,
  options?: OptionType
) {
  const { initialData, ...rest } = options ?? {};
  return useQuery({
    queryKey: [getProductPath(queryParams)],
    queryFn: async () => {
      const resp = await getApiV2ProductsId(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw resp.data;
      }

      return resp.data;
    },
    ...rest,
    initialData,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
